module.exports = __webpack_public_path__ + "img/dashboardTour2.42fffcd8.svg";